export const patchLevels = ['common', 'uncommon', 'rare', 'epic', 'legendary'];
export const patchLevelColors = Object.freeze({common:'#8A8577',uncommon:'#627A4D',rare:'#477493',epic:'#805D88',legendary:'#BE9346'});
export const patchLevelColor = level => patchLevelColors[level || 'common'] || patchLevelColors.common;
export const patchLevelLabel = level => (level || 'common').replace(/^./, letter => letter.toUpperCase());
export const hiddenPatchImage = (images, level, legacy = '') => images ? images[level || 'common'] || '' : legacy || '';
